import { AdvancedFilters } from "../../types/filters";
import SelectDropdown from "./SelectDropdown";

interface DropdownTypes {
  validationErrors: Record<string, boolean>;
  filters: any;
  dropdownOptions: any;
  handleFilterChange: (
    key: keyof AdvancedFilters,
    value: string | string[]
  ) => void;
  label: string;
  boldLabel?: boolean;
  filterKey: keyof AdvancedFilters;
  className?: string;
  disabled?: boolean;
}

const Dropdown: React.FC<DropdownTypes> = ({
  validationErrors,
  filters,
  dropdownOptions,
  handleFilterChange,
  label,
  boldLabel = true,
  filterKey,
  disabled = false,
  className = "",
}) => {
  return (
    <>
      <div>
        <label
          style={{
            fontSize: "11px",
            paddingLeft: "5px",
            fontWeight: boldLabel ? 600 : 400,
            color: boldLabel ? "" : "#a0b0c0",
          }}
        >
          {label}
        </label>
        <SelectDropdown
          key={filterKey}
          label=""
          disabled={disabled}
          isError={validationErrors[filterKey]}
          value={filters[filterKey]}
          filterKey={filterKey}
          options={dropdownOptions[filterKey]}
          className={className}
          onChange={(value) =>
            handleFilterChange(
              filterKey,
              Array.isArray(value) ? value[0] ?? "" : value
            )
          }
        />
      </div>
    </>
  );
};

export default Dropdown;
